module.exports = __webpack_public_path__ + "img/client-arcplan-group.fe4a025e.jpeg";